<template>
  <b-container>
    <b-row>
      <h2>{{ $t("tracking.vehicleType.list") }}</h2>
      <success-fade-alert ref="alert" :msg="alert.success" />
      <fade-alert-danger ref="danger" :msg="alert.error" />
    </b-row>
    <b-row>        
      <router-link :to="'./create'">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <!-- <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <div v-if="tableFilters[field.filterKey] != null">		
                <b-form-select
                    v-if="field.filterKey == 'vehicleTypeActive'"
                    :options="optionsBoolean"
                    v-model="tableFilters[field.filterKey]"
                >
                </b-form-select>
                <b-form-input
                  v-else
                  v-model="tableFilters[field.filterKey]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template> -->
        <template v-slot:cell(actions)="data">
          <router-link
            v-if="isVehicleTypeEditable(data.item)"
            class="desktop-buttons"
            :to="getUrlEdit(data.item)"
          >
            <b-button size="sm" class="btn-checklist">{{
              $t("geral.edit")
            }}</b-button>
          </router-link>
          <router-link
            v-else
            class="desktop-buttons"
            :to="getUrlEdit(data.item)"
          >
            <b-button size="sm" class="btn-checklist">{{
              $t("geral.detalhes")
            }}</b-button>
          </router-link>

          <b-button
            v-if="isVehicleTypeActive(data.item)"
            size="sm"
            class="btn-checklist ml-2"
            @click="vechicleTypeDeactivate(data.item)"
            >{{ $t("geral.delete") }}</b-button
          >
          <b-button
            v-else
            size="sm"
            class="btn-checklist ml-2"
            @click="vehicleTypeActivate(data.item)"
            >{{ $t("geral.activate") }}</b-button
          >
        </template>
        <template v-slot:cell(ativo)="data">
          {{ data.value ? "Sim" : "Não" }}
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        />
      </b-col>
      <b-col>
        <label for="perPageSelect"
          >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de
          {{ tableRowCount }}</label
        >
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-form-select
              v-model="tablePerPage"
              id="perPageSelect"
              size="sm"
              :options="tablePageOptions"
            />
          </b-col>
          <b-col>
            <label for="perPageSelect">Registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  name: "FormSchedules",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
  },
  data: function () {
    return {
      alert: {
        error: "",
        success: "",
      },
      isBusy: false,
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "vehicleTypeId",
          filterKey: "vehicleTypeId",
          sortable: false,
          label: "Id",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "vehicleTypeName",
          filterKey: "vehicleTypeName",
          label: "Nome",
          sortable: true,
        },
        {
          key: "vehicleTypeDescription",
          filterKey: "vehicleTypeDescription",
          label: "Descrição",
          sortable: true,
        },
        {
          key: "vehicleTypeActive",
          filterKey: "vehicleTypeActive",
          label: "Ativo",
          sortable: true,
          formatter: (value, key, item) => {
            if (value) {
              return "Sim";
            }
            return "Não";
          },
        },
      ],
      optionsBoolean: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      tableFilters: {
        vehicleTypeId: "",
        vehicleTypeName: "",
        vehicleTypeDescription: "",
        vehicleTypeActive: true,
      },
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    getUrlEdit(vehicleType) {
      console.log(vehicleType);
      return `/trackingShippingCompany/vehicleType/edit/${vehicleType.vehicleTypeId}`;
    },
    getUrlFilledDetails(vehicleType) {
      return "/trackingShippingCompany/vehicleType/details/" + vehicleType.checklistId;
    },
    isVehicleTypeActive(vehicleType) {
      if (vehicleType) {
        return vehicleType.vehicleTypeActive;
      }
      return false;
    },
    isVehicleTypeEditable(vehicleType) {
      console.log(`vehicleType: ${vehicleType}`);
      if (!this.isVehicleTypeActive(vehicleType)) {
        return false;
      }
      if (!vehicleType) {
        return false;
      }
      if (vehicleType.isInUse) {
        return false;
      }
      return true;
    },
    myProvider(ctx) {
      this.isBusy = true;

      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: ctx.perPage,
        vehicleTypeId: ctx.filter.vehicleTypeId,
        vehicleTypeName: ctx.filter.vehicleTypeName,
        vehicleTypeDescription: ctx.filter.vehicleTypeDescription,
        vehicleTypeActive: true
      };

      console.log(apiParam);

      return this.$api
        .post("/vehicleType/all", apiParam)
        .then((response) => {
          const items = response.data.items;
          console.log(items);
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          return items;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
            this.isBusy = false;
            this.tableRowCount = 0;
            return [];
          }
        });
    },
    vehicleTypeActivate(vehicleType) {
      this.$api
        .get("/vehicleType/activate/" + vehicleType.vehicleTypeId.toString())
        .then((response) => {
          vehicleType.vehicleTypeActive = true;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
    vechicleTypeDeactivate(vehicleType) {
      this.$api
        .get("/vehicleType/deactivate/" + vehicleType.vehicleTypeId.toString())
        .then((response) => {
          vehicleType.vehicleTypeActive = false;
          this.alert.success = response.data.title;
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(`error: ${error}`);
          console.log(error);
          console.log(`error.response: ${error.response}`);
          console.log(error.response);

          this.alert.error =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },
};
</script>

<style scoped>
.btn-checklist {
  min-width: 95px;
}
</style>